module.exports = __webpack_public_path__ + "static/img/header.98a4501.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/admin/header.png
// module id = hAU1
// module chunks = 2